import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-frame-partner',
  template: `
    <div id="div{{id}}">
      <form
        #formNniIhm
        [id]="idForm"
        [action]="urlFunctionSanitized"
        target="_self"
        method="POST">
        <input
          type="hidden"
          name="ihmLaunchParams"
          [value]="nnih"/>
        <input
          type="hidden"
          name="targetFunction"
          value=""/>
        <input
          type="hidden"
          name="requestVersion"
          value="2"/>
      </form>
    </div>
  `,
  styleUrls: ['./frame-partner.component.scss']
})
export class FramePartnerComponent implements OnInit, AfterViewInit {

  @ViewChild('formNniIhm', { static: true }) formNniIhm: ElementRef;
  @Input() id: string;
  @Input() nnih: string;
  @Input() urlFunction: string;
  @Input() width: string;
  @Input() height: string;
  position = 'relative';


  constructor(
    private readonly sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.formNniIhm.nativeElement.submit();
  }

  get idForm(): string {
    return `formAuto${this.id}`;
  }

  get urlFunctionSanitized(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.urlFunction);
  }
}
